import { useEventOccurrencesQuery } from "@ticketingplatform/api/dist/event";
import { useIsFocused } from "@react-navigation/native";
import { useMemo } from "react";
import { QueryHookOptions } from "@apollo/client";
import {
  GetEventOccurrences,
  GetEventOccurrencesVariables,
} from "@ticketingplatform/api/dist/event/__generated__/GetEventOccurrences";
import { useVenueContext } from "contexts/VenueContext";
import { EventStatus } from "@ticketingplatform/api/dist/__generated__/globalTypes";

import { UseEventList } from "./types";

export const useEventList: UseEventList = (date) => {
  const { venue } = useVenueContext();
  const isFocused = useIsFocused();

  const options = useMemo<
    QueryHookOptions<GetEventOccurrences, GetEventOccurrencesVariables>
  >(() => {
    if (!isFocused || !date) {
      return {
        skip: true,
      };
    }

    return {
      variables: {
        ...date,
        filters: {
          status: { equals: EventStatus.PUBLISHED },
          ...(venue
            ? {
                venueId: { equals: venue.id },
              }
            : {}),
        },
        eventInclude: true,
        venueInclude: true,
        ticketsAggregationInclude: true,
      },
    };
  }, [date, isFocused, venue]);

  const { data, loading } = useEventOccurrencesQuery(options);

  return {
    loading,
    data: data?.eventOccurrences?.nodes || [],
  };
};
